<script setup>
import { ElAffix, ElAnchor, ElAnchorLink } from 'element-plus'
import { useRouter } from 'vue-router'
const lang = useI18n().locale.value;
const goToDariusDetail = () => {
  window.open('https://www.youtube.com/@DariusInvestTrading', '_blank')
}
const goToJaySiDetail = () => {
  window.open('https://www.youtube.com/@JaySirWealth', '_blank')
}
const isPC = ref(false)
const isAffixVisible = ref(true)

onMounted(() => {
    getTeacherDetail()
  if (useDeviceType().value == 'pc') {
    isPC.value = true
    isAffixVisible.value = true
  } else {
    isPC.value = false
    isAffixVisible.value = false

  }
})

const handleShow = () => {
  isAffixVisible.value = !isAffixVisible.value
}
// 前往详情页面
const router = useRouter()
const gotoDetail = (type) => {
  if (lang === 'cn') {
    router.push(`/global_detail?type=${type}`)

  } else {
    router.push(`/hk/global_detail?type=${type}`)
  }
}
const teacherList = ref([])
const getTeacherDetail = async () => {
  try{
    const params = {}
    const res = await getTeacherDetailParams(params)
    if (res.status === 0) {
      teacherList.value = res.data.list.sort((a,b) => a.sort - b.sort) || []
    } else {
      message.error(res.info || '获取老师列表失败')
    }
  }catch (err){
    console.log(err)
  }
}
const goToWantai = (item) => {
  if (lang === 'cn') {
      router.push({path: `/teacherdetail`,
        query: {
          emp_id: item.emp_id

      }})
    } else {
      router.push({path: `/hk/teacherdetail`,
        query: {

            emp_id: item.emp_id

      }})
    }
}

</script>

<template>
  <div>
    <div w-full bg-cover h-550 lt-xl:h-275 bg-center
      :style="{ backgroundImage: 'url(' + (isPC ? wealth_planning.cn.global_bg : wealth_planning.cn.m_global_bg) + ')' }">
      <div mwc relative h-full>
        <div text-left text-white pt-115 mb-99 lt-xl:(pt-47 mb-36)>
          <p text-40 fw l-n mb-37 text-accent lt-xl:(text-18 mb-10)>{{ $t('hqtz') }}</p>
          <p titz max-w-436 lt-xl:(text-13 max-w-236)>{{ $t('tgzshndfa1') }}</p>
        </div>
      </div>
    </div>
    <div flex>
      <div w="10%" lt-xl:w="0%">
        <el-affix v-show="isAffixVisible" :offset="109" mt-0 ml-0 :duration="500" text-14 lt-xl:(text-8)>
          <el-anchor :offset="109" w-120 lt-xl:(w-60)>
            <div class="fd-security" w-120 text-14 lt-xl:(text-8 w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>{{
              $t('fdhyfwtx') }} {{ $t('fdhyfwtx1') }}</div>
            <el-anchor-link :href="`#${'wancai-system'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>
                {{ $t('fdhyfwtx') }} {{ $t('fdhyfwtx1') }}
              </div>
            </el-anchor-link>
            <div class="fd-dived" w-120 lt-xl:(w-60)></div>
            <div class="fd-security" w-120 text-14 lt-xl:(text-8 w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>{{
              $t('wtkcfw') }}</div>
            <el-anchor-link :href="`#${'course-system'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>

                {{ $t('cctx') }}
              </div>

            </el-anchor-link>
            <el-anchor-link :href="`#${'service-system'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>

                {{ $t('fwtx') }}
              </div>
            </el-anchor-link>
            <el-anchor-link :href="`#${'service-form'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>
                {{ $t('fwxs') }}
              </div>
            </el-anchor-link>
            <el-anchor-link :href="`#${'service-idea'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>
                {{ $t('fwln') }}
              </div>
            </el-anchor-link>
            <el-anchor-link :href="`#${'service-team'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>
                {{ $t('fwttd1') }}
              </div>
            </el-anchor-link>
            <el-anchor-link :href="`#${'service-shot'}`">
              <div text-14 lt-xl:(text-8) w-120 lt-xl:(w-60 pt-8 pb-8 pl-6 pr-6) pt-16 pb-16 pl-12 pr-12>
                {{ $t('tzdktt') }}
              </div>
            </el-anchor-link>
          </el-anchor>
        </el-affix>
        <el-affix v-if="!isPC" :offset="!isAffixVisible ? 320 : 35">
          <div class="circle-button" ml-4 w-50 h-50 text-8 flex items-center justify-center rounded="50%">
            <p v-if="!isAffixVisible" @click="handleShow">{{ $t('zk') }}</p>
            <p v-else @click="handleShow">{{ $t('sq') }}</p>
          </div>

        </el-affix>
      </div>

      <div w="90%" lt-xl:w="100%">

        <!-- // 这里是第二部分是方德会员服务体系 -->
        <div id="wancai-system">
          <div w-full flex justify-center>
            <div class="certified-team" w-621 mt-60 text-center h-full lt-xl:(h-full w-339 text-21) bg-center
              bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto text-36>
              <p>{{ $t('fdhyfwtx') }}</p>
              <p>{{ $t('fdhyfwtx1') }}</p>
            </div>
          </div>
          <div class="member-level" text-18 line-height-25 lt-xl:(text-12 line-height-15 pl-16 pr-16 mt-12)>
            {{ $t('hydjfwjyyh') }}</div>
          <div flex justify-center mt-24 gap-3 lt-xl:(flex-wrap gap-4)>
            <!-- // 会员等级 -->
            <div w-239 bg-cover h-328 lt-xl:w="32%" lt-xl:(h-170) bg-center
              :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261191182788.png)' }"
              flex justify-center>
              <div mt-160 text-center lt-xl:(mt-80)>
                <div class="v1-level" text-18 line-height-25 mb-24 lt-xl:(mb-0 text-12 line-height-15)>{{ $t('v1pthy')
                  }}
                </div>
                <div class="class-standard" mb-10 text-16 line-height-24 mb-24 lt-xl:(text-12 line-height-15 mb-5)>
                  {{ $t('jbbz') }}</div>
                <div class="registration-criteria" text-21 line-height-29 lt-xl:(text-14 line-height-15)>{{ $t('zcwc')
                  }}
                </div>
              </div>
            </div>
            <div w-239 bg-cover h-328 lt-xl:w="32%" lt-xl:(h-170) bg-center
              :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261214905267.png)' }"
              flex justify-center>
              <div mt-160 text-center lt-xl:(mt-80)>
                <div class="v1-level" text-18 line-height-25 mb-24 lt-xl:(mb-0 text-12 line-height-15)>{{ $t('v2byhy')
                  }}
                </div>
                <div class="class-standard" mb-10 text-16 line-height-24 mb-24 lt-xl:(text-12 line-height-15 mb-5)>
                  {{ $t('jbbz') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)>{{ $t('jrjhzhch') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)><span class="money-type">{{
                    $t('ww') }}</span>{{ $t('gy') }}</div>
              </div>
            </div>
            <div w-239 bg-cover h-328 lt-xl:w="32%" lt-xl:(h-170) bg-center
              :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261214916577.png)' }"
              flex justify-center>
              <div mt-160 text-center lt-xl:(mt-80)>
                <div class="v1-level" text-18 line-height-25 mb-24 lt-xl:(mb-0 text-12 line-height-15)>{{ $t('v3hjhy')
                  }}
                </div>
                <div class="class-standard" mb-10 text-16 line-height-24 mb-24 lt-xl:(text-12 line-height-15 mb-5)>
                  {{ $t('jbbz') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)>{{ $t('jrjhzhch') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)><span class="money-type">{{
                    $t('50w') }}</span>{{ $t('gy') }}</div>
              </div>
            </div>
            <div w-239 bg-cover h-328 lt-xl:w="32%" lt-xl:(h-170) bg-center
              :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261214919912.png)' }"
              flex justify-center>
              <div mt-160 text-center lt-xl:(mt-80)>
                <div class="v1-level" text-18 line-height-25 mb-24 lt-xl:(mb-0 text-12 line-height-15)>{{ $t('v4bjhy')
                  }}
                </div>
                <div class="class-standard" mb-10 text-16 line-height-24 mb-24 lt-xl:(text-12 line-height-15 mb-5)>
                  {{ $t('jbbz') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)>{{ $t('jrjhzhch') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)><span class="money-type">{{
                    $t('100w') }}</span>{{ $t('gy') }}</div>
              </div>
            </div>
            <div w-239 bg-cover h-328 lt-xl:w="32%" lt-xl:(h-170) bg-center
              :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261214924313.png)' }"
              flex justify-center>
              <div mt-160 text-center lt-xl:(mt-80)>
                <div class="v1-level" text-18 line-height-25 mb-24 lt-xl:(mb-0 text-12 line-height-15)>{{ $t('v5zshy')
                  }}
                </div>
                <div class="class-standard" mb-10 text-16 line-height-24 mb-24 lt-xl:(text-12 line-height-15 mb-5)>
                  {{ $t('jbbz') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)>{{ $t('jrjhzhch') }}</div>
                <div class="registration-account" text-16 lt-xl:(text-10 line-height-15)><span class="money-type">{{
                    $t('500w') }}</span>{{ $t('gy') }}</div>
              </div>
            </div>
          </div>
          <!-- //这里放位图 -->
          <div id="wancai-system" flex justify-center>
            <img w="70%" lt-xl:w="95%" mt-30 mb-30 lt-xl:(pl-16 mt-12)
              :src="(isPC ? wealth_planning.cn.global_bg6 : wealth_planning.cn.m5_global_bg1)" alt="">
          </div>
          <!-- //这里做新的会员体系 -->
          <div flex justify-center mt-20>
            <div w="80%" lt-xl:w="95%">
              <table>
                <tr>
                  <th>
                    <span text-32 text-center lt-xl:(text-10) class="privileged-interest">{{ $t('zxqy') }}</span>
                  </th>
                  <th>
                    <div flex items-center flex-col lt-xl:(text-10)>
                      <img w-50 h-50 lt-xl:(w-30 h-30) src="https://imgoss.techfx88.com/www_img/www_upload/default17288900496907.png"
                        alt="">
                      <div>
                        {{ $t('v5zshy') }}
                      </div>
                    </div>
                  </th>
                  <th>
                    <div flex items-center flex-col lt-xl:(text-10)>

                      <img w-50 h-50 lt-xl:(w-30 h-30) src="https://imgoss.techfx88.com/www_img/www_upload/default17288930553346.png"
                        alt="">
                      <div>
                        {{ $t('v4bjhy') }}
                      </div>
                    </div>
                  </th>
                  <th>
                    <div flex items-center flex-col  lt-xl:(text-10)>
                      <img w-50 h-50 lt-xl:(w-30 h-30) src="https://imgoss.techfx88.com/www_img/www_upload/default17288930777953.png"
                        alt="">
                      <div>
                        {{ $t('v3hjhy') }}
                      </div>
                    </div>

                  </th>
                </tr>
                <tr>
                  <td>
                    <div flex items-center lt-xl:(flex flex-col)>
                      <img lt-xl:(flex justify-center) cursor-pointer @click="gotoDetail(1)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17288934953614.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }">{{ $t('wealth_management') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('gxhdz') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('qqwttzfw') }}</div>

                      </div>

                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="diamond-exclusive">{{ $t('zsxs') }}</p>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(2)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289587547056.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }"> {{$t('dksxzd2') }}</div>
                        <div text-14 lt-xl:(text-7)>{{$t('dksrdj') }}</div>
                        <div text-14 lt-xl:(text-7)>{{$t('yjljdkzx') }}</div>
                        <div text-14 lt-xl:(text-7)>{{$t('jzdfw') }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="platinum-exclusive">{{ $t('bjxs') }}</p>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>

                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(3)" w-70 h-70  lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289587941648.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }">{{ $t('yzjy') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('szzbdj') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('jsszjn') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('dsjjd') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('jsryybr') }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="platinum-exclusive">{{ $t('bjxs') }}</p>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">
                      </div>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(4)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289588399356.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }"> {{ $t('hqjjyb')}}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('sdty')}}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('zhzcqzlpz')}}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="platinum-exclusive">{{ $t('bjxs') }}</p>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>

                  </td>
                </tr>
                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(5)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289588696587.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }">{{ $t('zs1v1') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('pbsfw') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('jypb') }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="global-exclusive">{{ $t('hjjx') }}</p>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(6)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289595365132.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }">{{  $t('clqij') }}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('jyyjbg')}}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('sdfx')}}</div>
                        <div text-14 lt-xl:(text-7)>{{ $t('tqbwschq')}}</div>

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="global-exclusive">{{ $t('hjjx') }}</p>
                    </div>
                  </td>

                </tr>
                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img cursor-pointer @click="gotoDetail(7)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289595609166.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }">{{ $t('szxly') }}</div>

                        <div text-14 lt-xl:(text-7)> {{ $t('jdzxdy')}}
                        </div>
                        <div text-14 lt-xl:(text-7)>{{ $t('jjyhxgn')}}</div>

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="global-exclusive">{{ $t('hjjx') }}</p>
                    </div>
                  </td>

                </tr>

                <tr>
                  <td>
                    <div flex items-center  lt-xl:(flex flex-col)>
                      <img  cursor-pointer @click="gotoDetail(8)" w-70 h-70 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289595854099.png" alt="">
                      <div text-left ml-16 lt-xl:(ml-4 text-center)>
                        <div text-18 lt-xl:(text-10) :style="{ color: '#AA7322' }"> {{ $t('tzszxlk') }}</div>

                        <div text-14 lt-xl:(text-7)>{{ $t('xtszjx')}}

                        </div>
                        <div text-14 lt-xl:(text-7)> {{ $t('bzdjgrtx')}}</div>

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <p line-height-25 h-25 text-14 lt-xl:(text-10 h-18 line-height-18 w-70) w-100 class="global-exclusive">{{ $t('hjjx') }}</p>
                    </div>
                  </td>

                </tr>
              </table>
              <div flex flex-col items-center mt-20>
                <p text-32 color="#AA7322" font-600 lt-xl:(text-16 )>{{ $t('qthyfwxy') }}</p>
                <p mt-5 text-24 color="#AA7322" lt-xl:(text-12 )>{{ $t('v3v4v5jxs') }}</p>
              </div>
              <!-- // pc版 -->
              <table  v-if="isPC">
                <tr >
                  <th>
                    <span text-32 text-center lt-xl:(text-16) class="privileged-interest"> {{ $t('qtqy')}}</span>
                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(9)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289685856390.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('ffjy1')}}
                        </div>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>
                         {{ $t('jywy')}}</div>

                      </div>
                    </div>


                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(10)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686202418.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400> {{ $t('srly') }}</div>

                      </div>
                    </div>


                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(11)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686351254.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('mylq') }}</div>

                      </div>
                    </div>


                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(12)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686541982.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('szdcjs1') }}
                        </div>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>
                          {{ $t('sfk') }}</div>
                      </div>
                    </div>


                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(13)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686751722.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('fdzt1')}}</div>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('zhjj')}}</div>

                      </div>
                    </div>
                  </th>
                  <th>
                    <div w-110 flex flex-col items-center justify-start h="100%" mt-20>
                      <img cursor-pointer @click="gotoDetail(14)" w-70 h-66 object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686901723.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>{{ $t('0ptf') }}
                        </div>
                        <div text-14 :style="{ color: '#AA7322' }" font-400>
                          {{ $t('jygqs') }}</div>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  <td>
                    <div flex flex-col items-center>
                      <img w-70 h-70 src="https://imgoss.techfx88.com/www_img/www_upload/default17289607439832.png"
                        alt="">
                      <div text-14 mt-4>
                         {{ $t('v2byhy') }}
                      </div>

                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div flex flex-col items-center>
                      <img w-70 h-70 src="https://imgoss.techfx88.com/www_img/www_upload/default17289608692870.png"
                        alt="">
                      <div text-14 mt-4>

                        {{ $t('v1pthy') }}

                      </div>

                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>

                </tr>
              </table>

              <!-- // 移动端 -->
              <table v-else mt-20>
                <tr >
                  <th>
                    <span text-32 text-center lt-xl:(text-16) class="privileged-interest"> {{ $t('qtqy')}}</span>
                  </th>
                  <th>
                    <div flex flex-col items-center>
                      <img w-70 h-70 lt-xl:(w-30 h-30) object-contain src="https://imgoss.techfx88.com/www_img/www_upload/default17289607439832.png"
                        alt="">
                      <div text-14 mt-4 lt-xl:(text-12)>
                         {{ $t('v2byhy') }}
                      </div>

                    </div>
                  </th>
                  <th>
                    <div flex flex-col items-center>
                      <img w-70 h-70 lt-xl:(w-30 h-30) object-contain src="https://imgoss.techfx88.com/www_img/www_upload/default17289608692870.png"
                        alt="">
                      <div text-14 mt-4 lt-xl:(text-12)>

                        {{ $t('v1pthy') }}

                      </div>

                    </div>
                  </th>
                </tr>
                <!-- 六个点击 -->
                <tr>
                  <th :style="{background: '#FFFFFF'}">
                    <div flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(9)" w-70 h-66 lt-xl:(w-30 h-30)  object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289685856390.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('ffjy1')}} {{ $t('jywy')}}
                        </div>


                      </div>
                    </div>


                  </th>

                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(10)" w-70 h-66 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686202418.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400> {{ $t('srly') }}</div>

                      </div>
                    </div>


                  </th>

                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr >
                  <th :style="{background: '#FFFFFF'}">
                    <div flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(11)" w-70 h-66 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686351254.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('mylq') }}</div>

                      </div>
                    </div>


                  </th>

                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(12)" w-70 h-66 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686541982.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('szdcjs1')}}{{ $t('sfk') }}
                        </div>


                      </div>
                    </div>


                  </th>

                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">

                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th :style="{background: '#FFFFFF'}">
                    <div  flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(13)" w-70 h-66 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686751722.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('fdzt1')}}</div>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('zhjj')}}</div>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <div w-40 lt-xl:(w-20) class="empty-content">
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>
                    <div flex flex-col items-center justify-center h="100%">
                      <img cursor-pointer @click="gotoDetail(14)" w-70 h-66 lt-xl:(w-30 h-30) object-contain
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17289686901723.png" alt="">
                      <div flex flex-col items-center>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>{{ $t('0ptf') }}
                        </div>
                        <div text-14 lt-xl:(text-12) :style="{ color: '#AA7322' }" font-400>
                          {{ $t('jygqs') }}</div>
                      </div>
                    </div>
                  </th>

                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                  <td>
                    <div flex justify-center>
                      <img w-42 h-32 lt-xl:(w-30 h-20) src="https://imgoss.techfx88.com/www_img/www_upload/default17289571272356.png"
                        alt="">
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div w="100%" flex justify-center pl-36 pr-36 pt-36 text-14 line-height-25 lt-xl:(text-12 pl-16 pr-16 pt-16)
            class="combat-tips">
            <div w="80%">
              {{ $t('clqzzysx') }}
            </div>
          </div>
        </div>

        <div id="course-warp">
          <!-- // 第三部分 -->
          <!-- <div  w="95%" lt-xl:w="100%" bg-cover h-550 lt-xl:(h-full) bg-center mt-72 lt-xl:(mt-12)
            :style="{ backgroundImage: 'url(' + (isPC ? wealth_planning.cn.global_bg1 : wealth_planning.cn.m_global_bg1) + ')' }">
            <div mwc relative h-full flex items-center>
              <div text-left p-30 text-white mb-99 lt-xl:(pt-20)>
                <p class="wantai-title" text-32 lt-xl:(text-18)>{{ $t('wtkcfw') }}</p>
                <p class="wantai-sub-title" text-21 mt-20 lt-xl:(text-11 mt-10)>{{ $t('wcsxy') }}</p>
                <p class="wantai-content" w="55%" lt-xl:w="95%" text-16 mt-42 lt-xl:(text-10 mt-10)>{{ $t('wcsxyswtjk') }}
                </p>
                <p class="wantai-content" w="55%" lt-xl:w="95%" text-16 mt-24 lt-xl:(text-10 mt-10)>
                  {{ $t('clyjrkjyxgs') }}</p>
                <p class="wantai-content" w="55%" lt-xl:w="95%" text-16 mt-24 lt-xl:(text-10 mt-10)>
                  {{ $t('z2024nsq') }}</p>
              </div>
            </div>
          </div> -->
          <div id="course-system">
            <div w-full flex justify-center>
              <div class="certified-team" w-352 mt-60 text-center h-full lt-xl:(h-full w-199 text-21) bg-center
                bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                {{ $t('cctx') }}
              </div>
            </div>
            <div class="member-level" text-18 line-height-25 lt-xl:(text-12 line-height-15 pl-16 pr-16 mt-12)>
              {{ $t('dycybttz') }}</div>
            <div pyx pb-0>
              <div>
                <ul f-c-b flex-wrap flex-row lt-xl:(justify-center)>
                  <li flex justify-center bg-no-repeat w="33%" h-373 gt:(h-473) lt-xl:(bg-contain h-300) bg-contain
                    :style="{ backgroundImage: 'url(' + wealth_planning.cn.global_bg2 + ')' }" px-30 mb-20 relative
                    lt-xl:(px-15 pt-100 mb-15) lt-xl:w='95%' cp :class="{ 'pt-30!': isEn }">
                    <div mt-120 gt:(mt-170) lt-xl:(mt-20) text-center>
                      <p  text-center titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('tzrmz') }}</p>
                      <p  titm lt-xl:mb-10 lt-xl:( mt-20) text-left :class="{ 'xl:text-16': isEn }">{{ $t('cccjc') }}
                      </p>
                      <!-- <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">客户资金独立托管于银行</p> -->
                    </div>

                  </li>
                  <li flex justify-center bg-no-repeat lt-xl:(bg-contain h-300) bg-contain
                    :style="{ backgroundImage: 'url(' + wealth_planning.cn.global_bg3 + ')' }" px-30 w="33%" h-373 gt:(h-473) mb-20
                    relative lt-xl:(px-15 pt-100 mb-15) lt-xl:w='95%' cp :class="{ 'pt-30!': isEn }">
                    <div mt-120 gt:(mt-170) lt-xl:(mt-20) text-center>
                      <p text-center titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('yydtzjydxy') }}
                      </p>
                      <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">
                        {{ $t('kkcsrtz') }}</p>
                      <!-- <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">客户资金独立托管于银行</p> -->
                    </div>

                  </li>
                  <li flex justify-center bg-no-repeat lt-xl:(bg-contain h-300) bg-contain
                    :style="{ backgroundImage: 'url(' + wealth_planning.cn.global_bg4 + ')' }" px-30 w="33%" h-373 gt:(h-473) mb-20
                    relative lt-xl:(px-15 pt-100 mb-15) lt-xl:w='95%' cp :class="{ 'pt-30!': isEn }">
                    <div  mt-120 gt:(mt-170) lt-xl:(mt-20) text-center>
                      <p text-center titc l-n mb-25 lt-xl:mb-15 :class="{ 'xl:text-20': isEn }">{{ $t('tzzsz') }}</p>
                      <p titm lt-xl:mb-10 :class="{ 'xl:text-16': isEn }">
                        {{ $t('kczzyhgjjxs') }}</p>
                    </div>

                  </li>
                </ul>
              </div>
            </div>

          </div>

          <!-- // 服务体系 -->
          <div id="service-system">
            <div w-full flex justify-center>
              <div class="certified-team" w-352 mt-60 text-center h-full lt-xl:(h-full w-199 text-21) bg-center
                bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                {{ $t('fwtx') }}
              </div>
            </div>
            <div class="member-level" text-18 line-height-25 lt-xl:(text-12 line-height-15 pl-16 pr-16 mt-12)>
              {{ $t('xqzxfw') }}</div>
            <div flex justify-center mt-24 gap-3 lt-xl:(block)>
              <!-- // 会员等级 -->
              <div w-528 bg-cover h-448 lt-xl:(h-full bg-contain bg-no-repeat ml-8) lt-xl:w="95%" bg-center
                :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261378767199.png)' }">
                <div class="member-bonus" text-21 line-height-59 lt-xl:(text-16 line-height-22 pt-12)>{{ $t('jchyfl') }}
                </div>

                <div p-40 pt-16 lt-xl:(pt-0)>
                  <div class="third-gift" text-21 lt-xl:(text-16 pt-20)>{{ $t('rhschl') }}</div>
                  <div flex items-center mt-16 lt-xl:(mt-16)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16 lt-xl:(text-12)>{{ $t('zykctx') }}</div>

                  </div>
                  <div mt-16 mb-16 lt-xl:(text-12 mt-8 mb-8)>
                    <div>{{ $t('01gmg') }}</div>
                    <div>{{ $t('02mfhj') }}</div>
                    <div>{{ $t('03jcb') }}</div>
                    <div>{{ $t('04jcds') }}</div>
                    <div>{{ $t('05fwgfdj') }}</div>
                  </div>

                  <div flex items-center mt-16 lt-xl:(text-12 mt-8)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16>{{ $t('1v1fw') }}</div>

                  </div>
                  <div flex items-center mt-16 lt-xl:(text-12 mt-8)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16>{{ $t('mfkcj') }}</div>

                  </div>

                </div>
              </div>
              <div w-528 bg-cover h-448 lt-xl:(h-full bg-contain bg-no-repeat ml-8) lt-xl:w="95%" bg-center
                :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261378767199.png)' }">
                <div class="member-bonus" text-21 line-height-59 lt-xl:(text-16 line-height-22 pt-32)>{{ $t('jjhyfl') }}
                </div>

                <div p-40 pt-6 pt-16 lt-xl:(pt-10)>
                  <div flex items-center lt-xl:(text-12 mt-8)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16>{{ $t('sczxdsts') }}</div>
                  </div>
                  <div flex items-center mt-16 lt-xl:(text-12 mt-8)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16>{{ $t('1v1fw') }}</div>
                  </div>
                  <div flex items-center mt-16 lt-xl:(text-12 mt-8)>
                    <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                    <div ml-16>{{ $t('mfkcj') }}</div>
                  </div>
                  <div class="divide-border" mt-16 mb-16 lt-xl:(mt-8 mb-8)>

                  </div>
                  <div class="third-gift" lt-xl:(text-12 mt-8)>{{ $t('jywydlb') }}</div>

                  <div flex>
                    <div flex items-center mt-6 w-230 lt-xl:(text-12 mt-8 w-170)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('szdcjs') }}</div>

                    </div>
                    <div flex items-center mt-6 ml-70 lt-xl:(text-12 mt-8 ml-10)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('clqij') }}</div>

                    </div>
                  </div>
                  <div flex>
                    <div flex items-center mt-6 w-230 lt-xl:(text-12 mt-8 w-170)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('lkjijs') }}</div>

                    </div>
                    <div flex items-center mt-6 ml-70 lt-xl:(text-12 mt-8 ml-10)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('yzjy1') }}</div>

                    </div>
                  </div>
                  <div flex>
                    <div flex items-center mt-6 w-230 lt-xl:(text-12 mt-8 w-170)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('fdztjjzh') }}</div>

                    </div>
                    <div flex items-center mt-6 ml-70 lt-xl:(text-12 mt-8 ml-10)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('hwjjyb1') }}</div>

                    </div>
                  </div>
                  <div flex>
                    <div flex items-center mt-6 w-230 lt-xl:(text-12 mt-8 w-170)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('ffyhjywy') }}</div>

                    </div>
                    <div flex items-center mt-6 ml-70 lt-xl:(text-12 mt-8 ml-10)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('cfgl1') }}</div>

                    </div>
                  </div>
                  <div flex justify-start>
                    <div flex items-center mt-6 lt-xl:(text-12 mt-8)>
                      <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                      <div ml-16>{{ $t('szxly1') }}</div>

                    </div>

                  </div>


                </div>
              </div>

            </div>
            <div w="100%" pl-36 pr-36 pt-36 text-14 line-height-25 lt-xl:(text-12 pl-16 pr-16 pt-16)
              class="combat-tips">
              <div>
                {{ $t('clqzzysx1') }}
              </div>
            </div>

          </div>
          <!-- // 服务形式 -->
          <div id="service-form">
            <div w-full flex justify-center>
              <div class="certified-team" w-352 mt-60 text-center h-full lt-xl:(h-full w-199 text-21) bg-center
                bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                {{ $t('fwxs') }}
              </div>
            </div>
            <div flex items-center justify-center mt-20 lt-xl:(block)>
              <div w="40%" lt-xl:w="100%">
                <div flex items-center lt-xl:(pl-16)>
                  <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                  <div ml-16 w="90%" text-20 lt-xl:(text-12)>
                    {{ $t('xttg') }}<span class="text-mark" text-20 lt-xl:(text-12)>{{ $t('xszbyt') }}</span>{{
                    $t('yqtdzj') }}
                  </div>
                </div>
                <div flex items-center mt-80 lt-xl:(mt-12) lt-xl:(pl-16)>
                  <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                  <div ml-16 w="90%" text-20 lt-xl:(text-12)>
                    <span class="text-mark" text-20 lt-xl:(text-12)>{{ $t('szmn') }}</span>{{ $t('zwxytgygbzd') }}
                  </div>
                </div>
                <div flex items-center mt-80 lt-xl:(mt-12) lt-xl:(pl-16)>
                  <div class="circle-mark" w-16 h-16 lt-xl:(w-8 h-8)></div>
                  <div ml-16 w="90%" text-20 lt-xl:(text-12)>
                    <span class="text-mark" text-20 lt-xl:(text-12)>{{ $t('ydyfd') }}</span>{{ $t('gsgjxygxhxq') }}
                  </div>
                </div>

              </div>
              <div>
                <img w-535 lt-xl:w="95%" lt-xl:(pl-16 mt-12)
                  src="https://imgoss.techfx88.com/www_img/www_upload/default17261361998322.png" alt="">
              </div>
            </div>
          </div>
          <!-- // 服务理念 -->

          <div id="service-idea">
            <div w-full flex justify-center>
              <div class="certified-team" w-352 mt-60 text-center h-full lt-xl:(h-full w-199 text-21 mt-20) bg-center
                bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                {{ $t('fwln') }}
              </div>
            </div>
            <div class="member-level" text-18 line-height-25 lt-xl:(text-12 line-height-15 pl-16 pr-16 mt-12)>
              {{ $t('swytztz') }}</div>
            <div flex justify-center mt-24 gap-3 lt-xl:(flex-wrap mt-0)>
              <!-- // 会员等级 -->
              <div w-599 bg-cover h-201 bg-center lt-xl:w="90%" lt-xl:(bg-contain bg-no-repeat h-150)
                :style="{ backgroundImage: isPC ? 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261372056127.png)' : 'url(https://imgoss.techfx88.com/www_img/www_upload/default17274233859421.png)' }"
                flex justify-center>
                <div mt-26 text-center>
                  <div class="invest-latitude" mb-10 text-21 line-height-29 lt-xl:(text-16)>{{ $t('tzzwd') }}</div>
                  <div class="student-provided" text-16 line-height-24 pl-40 pr-40 lt-xl:(text-10 line-height-14 pl-16
                    pr-16)>{{ $t('wmszzztzzsj') }}</div>
                </div>
              </div>
              <div w-599 bg-cover h-201 lt-xl:w="90%" lt-xl:(bg-contain bg-no-repeat h-150) bg-center
                :style="{ backgroundImage: isPC ? 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261372056127.png)' : 'url(https://imgoss.techfx88.com/www_img/www_upload/default17274233859421.png)' }"
                flex justify-center>
                <div mt-26 text-center>
                  <div class="invest-latitude" mb-10 text-21 line-height-29 lt-xl:(text-16)>{{ $t('fxswd') }}</div>
                  <div class="student-provided" pl-40 pr-40 text-16 line-height-24 lt-xl:(text-10 line-height-14 pl-16
                    pr-16)>
                    {{ $t('wmytzytzfxtd') }}
                  </div>
                </div>
              </div>
            </div>
            <div flex justify-center mt-24 gap-3 lt-xl:(flex-wrap mt-0)>
              <!-- // 会员等级 -->
              <div w-599 bg-cover h-201 lt-xl:w="90%" lt-xl:(bg-contain bg-no-repeat h-150) bg-center
                :style="{ backgroundImage: isPC ? 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261372056127.png)' : 'url(https://imgoss.techfx88.com/www_img/www_upload/default17274233859421.png)' }"
                flex justify-center>
                <div mt-26 text-center>
                  <div class="invest-latitude" mb-10 text-21 line-height-29 lt-xl:(text-16)>{{ $t('fwgwjd') }}</div>
                  <div class="student-provided" pl-40 pr-40 text-16 line-height-24 lt-xl:(text-10 line-height-14 pl-16
                    pr-16)>
                    {{ $t('xykxzscf') }}</div>
                </div>
              </div>
              <div w-599 bg-cover h-201 lt-xl:w="90%" lt-xl:(bg-contain bg-no-repeat h-150) bg-center
                :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261372056127.png)' }"
                flex justify-center>
                <div mt-26 text-center>
                  <div class="invest-latitude" mb-10 text-21 line-height-29 lt-xl:(text-16)>{{ $t('zykctx') }}</div>
                  <div class="student-provided" pl-40 pr-40 text-16 line-height-24 lt-xl:(text-10 line-height-14 pl-16
                    pr-16)>
                    {{ $t('xtdzytxjg') }}</div>
                </div>
              </div>




            </div>
          </div>

          <!-- //服务团队 -->
          <div id="service-team" w="95%" lt-xl:w="100%" bg-contain bg-no-repeat h-541 bg-center mt-72 mb-22 lt-xl:(mt-32
            h-300 )
            :style="{ backgroundImage: isPC ? 'url(' + (wealth_planning.cn.global_bg5) + ')' : 'url(' + (wealth_planning.cn.m4_global_bg1) + ')' }">
            <div mwc relative h-full>
              <div text-left p-30 text-white pt-115 mb-99 lt-xl:(pt-17 mb-36 p-00 pt-30)>
                <p class="fuwu-title" text-36 lt-xl:(text-18)>{{ $t('fwttd1') }}</p>
                <p class="wantai-content" w="55%" lt-xl:w="95%" mt-20 text-16 lt-xl:(text-10)>
                  {{ $t('wmdtt') }}
                </p>

              </div>
            </div>
          </div>

          <!-- //服务老师 -->
          <div>
            <div w-full flex justify-center>
              <div class="certified-team" w-445 mt-60 text-center h-full lt-xl:(h-full w-259 text-21 mt-0) bg-center
                bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                {{ $t('fwgwtd') }}
              </div>
            </div>
            <div flex justify-center mt-24 gap-3 flex-wrap lt-xl:(flex-wrap gap-12 mt-0)>
            <div v-for="(item, index) in teacherList" :key="index" h="100%" lt-xl:w="45%">
              <div p--4 cursor-pointer pos-relative   @click="goToWantai(item)"   lt-gt:(h-410) h-355 w-277  bg-cover  lt-xl:w="100%" lt-xl:(bg-no-repeat h-261)  flex bg-center-top
              :style="{ backgroundImage: `url(${item.picture})` }" flex-col mb-130 lt-xl:(mb-10)
              >
              <img p-0  src="https://imgoss.techfx88.com/www_img/www_upload/default17295831694721.png" alt="">
              <div text-center pos-absolute lt-zt:top="76%" top="87%" lt-xl:top="73%" left-40 lt-xl:(left-20)>
                  <div class="teacher-name" line-height-25 text-18 mb-25 lt-xl:(text-12 line-height-14)>{{item.full_name_en }} {{ lang === 'cn' ? item.full_name : item.full_name_tc }}
                  </div>
                  <div mb-30 lt-xl:(text-12 line-height-14 mb-10)>
                    <div>{{ $t('zsgwfw') }}</div>
                    <div>whatsapp：{{ item.whatsapp }}</div>
                  </div>
                </div>

            </div>
            </div>
          </div>

            <div>
            </div>
          </div>

          <!-- //投资大咖团队 -->

          <div id="service-shot" w="100%" flex justify-center lt-xl:(p-12)>
            <div mt-74 mb-68 w="90%" lt-xl:(mt-24 mb-24) lt-xl:w="100%">
              <div w-full flex justify-center>
                <div class="certified-team" w-352 mt-0 text-center h-full lt-xl:(h-full w-199 text-21 mt-20) bg-center
                  bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner3 + ')' }" overflow-auto font-size-42>
                  {{ $t('tzdktt') }}
                </div>
              </div>
              <div flex justify-center mt-24 gap-24 lt-xl:(block)>
                <div>
                  <div w-588 bg-cover h-314 bg-center lt-xl:(h-190) lt-xl:w="100%"
                    :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261408284485.png)' }">
                    <div p-40 pt-16 lt-xl:(p-0 ml-20 pt-20)>
                      <div class="third-gift" lt-xl:(text-12 mt-8) lt-xl:(p-0)> {{ $t('cfdkdariusl') }}</div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('12nsz') }}</div>
                      </div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)> {{ $t('2gysx') }}</div>

                      </div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('scyxgs') }}</div>

                      </div>

                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div w="50%" ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('jtzjzh') }}</div>

                      </div>

                    </div>
                  </div>
                  <div flex items-center justify-between mt-22 lt-xl:(mt-12)>
                    <div flex items-center>
                      <img w-65 lt-xl:(w-30)
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17261412162539.png" alt="">
                      <div ml-16 lt-xl:(ml-8 text-10)>
                        <p>{{ $t('darius1') }}</p>
                        <p>{{ $t('hydy') }}</p>
                      </div>
                    </div>

                    <div lt-xl:( text-12 w-45 h-20 line-height-20 rounded-10) w-110 h-32 line-height-32 rounded-20
                      :style="{ cursor: 'pointer' }" @click="goToDariusDetail()" class="subscribe-to">
                      {{ $t('dy') }}
                    </div>
                  </div>
                </div>
                <div>
                  <div w-588 bg-cover h-314 lt-xl:(h-190 mt-16) lt-xl:w="100%" bg-center
                    :style="{ backgroundImage: 'url(https://imgoss.techfx88.com/www_img/www_upload/default17261416032067.png)' }">

                    <div p-40 pt-16 lt-xl:(p-0 ml-20 pt-20)>
                      <div class="third-gift" lt-xl:(text-12 mt-8) lt-xl:(p-0)> {{ $t('daka') }}</div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('13nian') }}</div>
                      </div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('gldzh') }}</div>
                      </div>
                      <div flex items-center mt-16 lt-xl:(mt-4)>
                        <div class="circle-hollow" w-12 h-12 lt-xl:(w-6 h-6)></div>
                        <div ml-16 lt-xl:(text-10 mt-0 ml-6)>{{ $t('scbocz') }}</div>

                      </div>


                    </div>
                  </div>
                  <div flex items-center justify-between mt-22 lt-xl:(mt-12)>
                    <div flex items-center>
                      <img w-65 lt-xl:(w-30)
                        src="https://imgoss.techfx88.com/www_img/www_upload/default17261416294892.png" alt="">
                      <div ml-16 lt-xl:(ml-8 text-10)>
                        <p>{{ $t('jaysir') }}</p>
                        <p>{{ $t('hydy') }}</p>
                      </div>
                    </div>
                    <div lt-xl:( text-12 w-45 h-20 line-height-20 rounded-10) w-110 h-32 line-height-32 rounded-20
                      :style="{ cursor: 'pointer' }" @click="goToJaySiDetail()" class="subscribe-to">
                      {{ $t('dy') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div w="100%" pl-36 pr-36 pt-0 pb-36 text-14 line-height-25 lt-xl:(text-12 pl-16 pr-16 pt-16)
            class="combat-tips">
            <div>
              {{ $t('clqzzysx2') }}

            </div>
            <div>
              {{ $t('clqzzysx3') }}

            </div>
            <div>
              {{ $t('clqzzysx4') }}

            </div>
            <div>
              {{ $t('clqzzysx5') }}

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.certified-team {
  background-size: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #AA7322;
  font-style: normal;
}

.member-level {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #373B50;
  font-style: normal;
  text-align: center;
}

.v1-level {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #373B50;
  line-height: 25px;
  font-style: normal;
}

.class-standard {
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  color: #727272;
  font-style: normal;
}

.registration-criteria {

  font-family: PingFangSC, PingFang SC;
  font-weight: 500;

  color: #373B50;

  font-style: normal;
}

.registration-account {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;

  color: #373B50;
  font-style: normal;
}

.money-type {
  font-family: PingFangSC, PingFang SC;
  font-size: 24;
  color: #98461D;
  font-weight: 600;

}

.normal-level {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;

  color: #373B50;

  text-align: left;
  font-style: normal;
}

.member-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;

  color: #AA7322;

  font-style: normal;

}

.wantai-title {
  font-family: AlibabaPuHuiTi_2_95_ExtraBold;

  color: #FFFFFF;
  line-height: 23px;
  text-align: left;
  font-style: normal;
  font-weight: bold;
}

.wantai-sub-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;

  color: #FFFFFF;
  line-height: 29px;
  text-align: left;
  font-style: normal;
}

.wantai-content {

  font-family: PingFangSC, PingFang SC;

  color: #FFFFFF;
  text-align: justify;
  font-style: normal;
}

.circle-mark {

  background: #AA7322;
  border-radius: 50%;
}

.text-mark {
  color: #AA7322;

  font-family: Semibold;
}

.invest-latitude {

  font-family: PingFangSC, PingFang SC;
  font-weight: 600;

  color: #AA7322;

  text-align: center;
  font-style: normal;
}

.student-provided {

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;

  color: #373B50;

  text-align: justify;
  font-style: normal;
}

.member-bonus {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
}

.third-gift {
  color: #AA7322;

  text-align: left;
}

.divide-border {
  width: 90%;
  height: 1px;
  border: 1px solid #AA7322;
  opacity: 0.24;
}

.fuwu-title {

  font-family: PingFangSC, PingFang SC;
  font-weight: 600;

  color: #DBB882;

  text-align: left;
  font-style: normal;
}

.teacher-name {


  font-family: AlibabaPuHuiTi_2_95_ExtraBold;

  color: #FFFFFF;

  font-style: normal;
}

.large-team {

  background: linear-gradient(90deg, rgba(213, 171, 71, 0) 0%, #E8DCCB 100%);
  border-radius: 23px;
  font-family: AlibabaPuHuiTi_2_95_ExtraBold;
  color: #AA7322;
  text-align: left;
  font-style: normal;
}

.circle-hollow {

  border: 3px solid #AA7322;
  border-radius: 50%;
  border-left-width: 50%;
}

.subscribe-to {

  background: #AA7322;

  text-align: center;

  color: #FFFFFF;
}

.member-sub-title {
  font-family: Semibold;
  color: #373B50;

  font-weight: 400;


}

.combat-tips {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #9B9B9B;
  text-align: justify;
  font-style: normal;
}

:deep(.el-anchor__item) {

  // width: 120px;
  // border: 1px solid;
  --el-anchor-bg-color: none;




}

:deep(.el-anchor__link) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #727272;
  font-style: normal;
  white-space: normal;
  text-align: center;
  display: flex;
  align-items: center;
}

:deep(.el-anchor__link.is-active) {
  color: #AA7322;
  background: #F7F7F7;

}

:deep(.el-anchor__marker) {
  display: none;
}

:deep(.el-anchor__list) {
  padding-left: 0px !important;
}

// :deep(.el-anchor.el-anchor--vertical) {

// }
:deep(.el-anchor) {
  box-shadow: 0px 2px 4px 0px rgba(190, 190, 190, 0.5);
}

.fd-security {
  background: #AA7322;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  font-style: normal;
  white-space: normal;
  text-align: center;
  display: flex;
  align-items: center;


}

.fd-dived {

  height: 12px;
  background: #F7F7F7;
}

.circle-button {
  background-color: #AA7322;
  color: #ffffff;

}

// 会员权益

table {
    width: 100%;
    border-collapse: collapse;
  }
  th, td {
    border: 0px solid #ddd;
    padding: 8px;
    text-align: center;
    height: 130px;
  }
  th {
    background: #FFFBF5;
  }
  tr:nth-child(2n-1) {
    background: #FFFBF5;
    height: 130px;
  }
  tr:nth-child(2n) {
    background: #FFFFFF;
    height: 130px;
  }

    .privileged-interest {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #AA7322;
      font-style: normal;
    }
    .diamond-exclusive {
      background: #E3E6FF;
      border-radius: 20px;

    }

    .empty-content {

      height: 6px;
      background: #AA7322;
      border-radius: 3px;
      opacity: 0.3;
    }

    .platinum-exclusive {

      background: #E4EEF8;
      border-radius: 20px;

    }

    .global-exclusive {
      background: #F7E3B5;
      border-radius: 20px;

    }
</style>
